import { useDispatch, useSelector } from "react-redux";
import SharedDiv from "../../Components/SharedDiv/SharedDiv";
import AcademicAchievement from "../../Pages/Submitter/WorkInformationAndAcademic/AcademicAchievement";
import CurrentWorkSpecialtyInformation from "../../Pages/Submitter/WorkInformationAndAcademic/CurrentWorkSpecialtyInformation";
import PracticalExperiencesTable from "../../Pages/Submitter/WorkInformationAndAcademic/PracticalExperiences";
import VoluntaryCommunityWork from "../../Pages/Submitter/WorkInformationAndAcademic/VoluntaryCommunityWork";
import ButtonAHSF from "../../Components/ButtonAHSF";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  GetOneAcademicAchievement,
  UpdateAcademicAchievement,
} from "../../Redux/Reducers/Submitter/AcademicAchievement";
import {
  GetOneCurrentJobInformationSpecialization,
  UpdateCurrentJobInformationSpecialization,
} from "../../Redux/Reducers/Submitter/CurrentJobInformationSpecialization";
import { ValidationWorkAndEducationInformation } from "../../Redux/Reducers/Submitter/WorkAndEducationInformationValidation";
import PopupAHSF from "../../Components/PopupAHSF";
import ValidationView from "../../Components/ValidationView";

// import "bootstrap/dist/css/bootstrap.min.css";
const WorkInformationAndAcademic = () => {
   const {ApplicationInformationId} = useParams();
  const [
    ValidationWorkAndEducationInformationResult,
    setValidationWorkAndEducationInformationResult,
  ] = useState([]);
  const [
    PopupComponentValidationViewStatus,
    setPopupComponentValidationViewStatus,
  ] = useState(false);
  const [
    refreshDataFromClosePagePracticalExperiences,
    setRefreshDataFromClosePagePracticalExperiences,
  ] = useState(false);
  const [
    refreshDataFromClosePageVoluntaryCommunityWork,
    setRefreshDataFromClosePageVoluntaryCommunityWork,
  ] = useState(false);
  const lang = useSelector((state) => state.languageReducer.Language);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const state = useSelector((state) => {
    return {
      ActiveRound: state.ApplicationInformation.ActiveRound,
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
    };
  });
  ///////////////////////////////////////AcademicAchievement///////////////////////////////////////////
  const academicAchievement = useSelector(
    (state) => state.AcademicAchievement.AcademicAchievement
  );
  const [
    specializationCertificateAttachment,
    setSpecializationCertificateAttachment,
  ] = useState(null);
  const [yearObtainingCertificateId, setYearObtainingCertificateId] =
    useState(null);
  useEffect(() => {
    dispatch(
      GetOneAcademicAchievement({
        applicationInformationId: localStorage.getItem(
          "ApplicationInformationId"
        )||
          ApplicationInformationId,
      })
    );
  }, [ApplicationInformationId]);

  const UpdateAcademicAchievementFunction = async () => {
    console.log(academicAchievement, "ssssjiidjiiiwjjjw");

    // const formData = {
    //   AcademicAchievementId: academicAchievement?.academicAchievementId,
    //   SpecializationCertificateAttachment:
    //     academicAchievement?.specializationCertificateAttachment,
    //   YearOfGraduation_TimePeriodId:
    //     academicAchievement?.yearOfGraduation_TimePeriodId?academicAchievement.yearOfGraduation_TimePeriodId:null,
    //   ApplicationInformationId:localStorage.getItem("ApplicationInformationId")||
    //       ApplicationInformationId,

    // };
    const formData = new FormData();
    formData.append(
      "AcademicAchievementId",
      academicAchievement?.academicAchievementId
    );
    formData.append(
      "SpecializationCertificateAttachment",
      academicAchievement?.specializationCertificateAttachment
    );
    if (academicAchievement?.yearOfGraduation_TimePeriodId) {
      formData.append(
        "YearOfGraduation_TimePeriodId",
        academicAchievement.yearOfGraduation_TimePeriodId
      );
    }
    formData.append(
      "ApplicationInformationId",
      localStorage.getItem("ApplicationInformationId")||
          ApplicationInformationId,
    );
    formData.append("file", academicAchievement?.file);
    

    var result = await dispatch(UpdateAcademicAchievement(formData));
    console.log(result, "ttttttt");

    return result?.payload?.code;
  };
  useEffect(() => {
    setSpecializationCertificateAttachment(
      academicAchievement?.specializationCertificateAttachment
    );
  }, [academicAchievement]);
  ////////////////////////////////////End AcademicAchievement//////////////////////////////////////////////

  ///////////////////////////////////CurrentJobInformationSpecialization///////////////////////////////////////////////
  const [academicRankId, setAcademicRankId] = useState(null);
  const [city, setCity] = useState(null);
  const [college, setCollege] = useState(null);
  const [countryId, setCountryId] = useState(null);
  const [department, SetDepartment] = useState(null);
  const [generalSpecialization, setGeneralSpecialization] = useState(null);
  const [jobTitle, setJobTitle] = useState(null);
  const [subspecialization, setsubspecialization] = useState(null);
  const [university_Institution, setuniversity_Institution] = useState(null);

  const currentJobInformationSpecialization = useSelector(
    (state) =>
      state.CurrentJobInformationSpecialization
        .CurrentJobInformationSpecialization
  );
  useEffect(() => {
    dispatch(
      GetOneCurrentJobInformationSpecialization({
        applicationInformationId: localStorage.getItem(
          "ApplicationInformationId"
        )||
          ApplicationInformationId,
      })
    );
  }, []);

  useEffect(() => {
    setAcademicRankId(currentJobInformationSpecialization?.academicRankId);
    setCity(currentJobInformationSpecialization?.city);
    setCollege(currentJobInformationSpecialization?.college);
    setCountryId(currentJobInformationSpecialization?.countryId);
    SetDepartment(currentJobInformationSpecialization?.department);
    setGeneralSpecialization(
      currentJobInformationSpecialization?.generalSpecialization
    );
    setJobTitle(currentJobInformationSpecialization?.jobTitle);
    setsubspecialization(
      currentJobInformationSpecialization?.subspecialization
    );
    setuniversity_Institution(
      currentJobInformationSpecialization?.university_Institution
    );
  }, [currentJobInformationSpecialization]);
  console.log(
    currentJobInformationSpecialization,
    "currentJobInformationSpecialization"
  );

  const UpdateCurrentJobInformationSpecializationFunction = async () => {
    var result = await dispatch(
      UpdateCurrentJobInformationSpecialization({
        currentJobInformationSpecializationId:
          currentJobInformationSpecialization?.currentJobInformationSpecializationId,
        countryId: currentJobInformationSpecialization?.countryId,
        city: currentJobInformationSpecialization?.city,
        university_Institution:
          currentJobInformationSpecialization?.university_Institution,
        college: currentJobInformationSpecialization?.college,
        department: currentJobInformationSpecialization?.department,
        jobTitle: currentJobInformationSpecialization?.jobTitle,
        academicRankId: currentJobInformationSpecialization?.academicRankId,
        generalSpecialization:
          currentJobInformationSpecialization?.generalSpecialization,
        subspecialization:
          currentJobInformationSpecialization?.subspecialization,
        applicationInformationId:
          currentJobInformationSpecialization?.applicationInformationId,
      })
    );
    return result?.payload?.code;
  };

  /////////////////////////////////End CurrentJobInformationSpecialization/////////////////////////////////////////////

  const SaveDataPage = () => {
    console.log(academicAchievement, "academicsssqqwedsdsffAchievement");

    UpdateAcademicAchievementFunction();
    UpdateCurrentJobInformationSpecializationFunction();
  };
  const closePopupComponentValidationViewStatus = () => {
    // Function to toggle the visibility of the validation popup
    if (PopupComponentValidationViewStatus) {
      setPopupComponentValidationViewStatus(false); // Closing the popup
    } else {
      setPopupComponentValidationViewStatus(true); // Opening the popup
    }
  };
  const SaveAndNext = async () => {
    var resultUpdateAcademicAchievement =
      await UpdateAcademicAchievementFunction();

    var resultUpdateCurrentJobInformationSpecialization =
      await UpdateCurrentJobInformationSpecializationFunction();
    console.log(
      resultUpdateAcademicAchievement,
      resultUpdateCurrentJobInformationSpecialization,
      "jjjjjjjjjjjjjjjjjjjjjjj"
    );
    if (
      resultUpdateAcademicAchievement == 200 &&
      resultUpdateCurrentJobInformationSpecialization == 200
    ) {
      var result = await dispatch(
        ValidationWorkAndEducationInformation({
          applicationInformationId: localStorage.getItem(
            "ApplicationInformationId"
          )||
          ApplicationInformationId,
          lang: lang,
        })
      );
      console.log(result.payload.result.length > 0, "result.payload");
      if (result.payload.result.length > 0) {
        setValidationWorkAndEducationInformationResult(result.payload.result);
        setPopupComponentValidationViewStatus(true);
      } else {
        navigate(
          "/ResearchersAward/ScientificContributionSubmittedForTheAwardScreen"
        );
      }
    }
  };

  console.log(state.ActiveRound, "vvvvvv");
  const disabled = state.ActiveRound;
  return state.ActiveRound || state.ActiveRound == false ? (
    <>
      <SharedDiv
        showTitle={true}
        titleNameEN="Academic Achievement"
        titleNameAR="التحصيل الأكاديمي"
        lang={lang}
        child={[
          <AcademicAchievement
            refreshDataFromClosePagePracticalExperiences={
              refreshDataFromClosePagePracticalExperiences
            }
            refreshDataFromClosePageVoluntaryCommunityWork={
              refreshDataFromClosePageVoluntaryCommunityWork
            }
            academicAchievement={academicAchievement}
            setSpecializationCertificateAttachment={
              setSpecializationCertificateAttachment
            }
            setYearObtainingCertificateId={setYearObtainingCertificateId}
            applicationGuid={""}
            disabled={disabled}
          />,
        ]}
      />

      <SharedDiv
        showTitle={true}
        titleNameEN="Current work and specialty information"
        titleNameAR="معلومات العمل الحالي والتخصص"
        lang={lang}
        child={[
          <CurrentWorkSpecialtyInformation
            currentJobInformationSpecialization={
              currentJobInformationSpecialization
            }
            setAcademicRankId={setAcademicRankId}
            setCity={setCity}
            setCollege={setCollege}
            setCountryId={setCountryId}
            SetDepartment={SetDepartment}
            setGeneralSpecialization={setGeneralSpecialization}
            setJobTitle={setJobTitle}
            setsubspecialization={setsubspecialization}
            setuniversity_Institution={setuniversity_Institution}
            disabled={disabled}
          />,
        ]}
      />

      <PracticalExperiencesTable
        setRefreshDataFromClosePagePracticalExperiences={
          setRefreshDataFromClosePagePracticalExperiences
        }
        refreshDataFromClosePagePracticalExperiences={
          refreshDataFromClosePagePracticalExperiences
        }
        applicationGuid={""}
        disabled={disabled}
      />

      <VoluntaryCommunityWork
        applicationGuid={""}
        disabled={disabled}
        setRefreshDataFromClosePageVoluntaryCommunityWork={
          setRefreshDataFromClosePageVoluntaryCommunityWork
        }
        refreshDataFromClosePageVoluntaryCommunityWork={
          refreshDataFromClosePageVoluntaryCommunityWork
        }
      />
      {!disabled ? (
        <div className="containerButtonMAin">
          <ButtonAHSF
            type={"submitter"}
            fieldsName="PreviousButton"
            lang={lang}
            onClick={() => {
              SaveDataPage();
              navigate("/ResearchersAward/ApplicationInformation");
            }}
            disabled={false}
            show={true}
          />
          <div className={`SaveButtonMarks ${lang === "ar" ? "rtl" : "ltr"}`}>
            <ButtonAHSF
              type={"submitter"}
              fieldsName="SaveButton"
              lang={lang}
              text="حفظ"
              onClick={() => {
                SaveDataPage();
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: lang == "ar" ? "تم الحفظ بنجاح" : "Saved Successfully",
                  showConfirmButton: false,
                  timer: 1500,
                  // width: "500px",
                });
              }}
              disabled={false}
              title={"حفظ"}
              show={true}
            />
          </div>

          <ButtonAHSF
            type={"submitter"}
            fieldsName="NextButton"
            lang={lang}
            onClick={() => {
              SaveAndNext();
            }}
            disabled={false}
            title={"التالي"}
            text={"التالي"}
            show={true}
          />
        </div>
      ) : (
        ""
      )}
      <PopupAHSF
        title={
          lang == "ar"
            ? "يرجى تعبئة الحقول المطلوبة"
            : "Please fill all the required fields"
        }
        componentBody={
          <ValidationView
            ValidationList={ValidationWorkAndEducationInformationResult}
          />
        }
        maxWidth="700px"
        maxHeight="800px"
        isPopupOpenStatus={
          PopupComponentValidationViewStatus &&
          ValidationWorkAndEducationInformationResult.length > 0
        } // Popup open status
        isPopupOpenFunction={closePopupComponentValidationViewStatus} // Function to close the popup
      />
    </>
  ) : (
    ""
  );
};

export default WorkInformationAndAcademic;
